module.exports = __webpack_public_path__ + "img/title-1.3c71a3a3.png";